<template>
  <div class="experience-vip-receive-result">
    <ym-popup class="experience-vip-receive-result-popup"
              v-model="visible"
              :close-on-click-overlay="closeOnClickOverlay"
              get-container="body"
    >
      <div v-if="status === 'success'"
           class="experience-vip-receive-result-success-container"
      >
        <div class="experience-vip-receive-result-success-container-content">
          <div class="success-info-title">
            领取成功
          </div>
          <div class="gift-list">
            <div class="gift-list-item"
                 v-ym-report:NEWGIFT2021_SUCCESS_JUMP_CLICK="{
                   url: '/million/read/select',
                 }"
                 @click="handleStartLearn"
            >
              <div class="gift-list-item-title">百万阅读7天体验会员</div>
              <div class="gift-list-item-action">去看看</div>
            </div>
            <div class="gift-list-item"
                 v-ym-report:NEWGIFT2021_SUCCESS_JUMP_CLICK="{
                   url: `/audio/${list[giftIndex].id}`,
                 }"
                 @click="handleToAudioDetail(list[giftIndex].id)"
            >
              <div class="gift-list-item-title">
                {{ list[giftIndex].title }}
              </div>
              <div class="gift-list-item-action">去看看</div>
            </div>
            <div class="gift-list-item coupon"
                 v-ym-report:NEWGIFT2021_SUCCESS_JUMP_CLICK="{
                   url: '/my/coupon',
                 }"
                 @click="handleToCoupon"
            >
              <div class="gift-list-item-title coupon">20元无门槛优惠券</div>
              <div class="gift-list-item-action coupon">立即使用</div>
            </div>
          </div>
        </div>
      </div>
      <div v-else
           class="experience-vip-receive-result-fail-container"
      >
        <div class="fail-header">领取失败</div>
        <div class="fail-info">
          <template v-if="isReceived">
            新人礼包每个账号只能领取一次，你已领取过了，不可重复领取哦。
          </template>
          <template v-else-if="!isNewMember">
            新人礼包为新用户专享，你暂不符合领取条件哦。
          </template>
        </div>
        <div class="fail-btn"
             @click="handleBack"
        >
          关闭
        </div>
      </div>
      <div class="experience-vip-receive-result-popup-close"
           @click.stop="handleClose(visible)"
      >
        <ym-icon name="round-close" />
      </div>
    </ym-popup>
  </div>
</template>

<script>
  import { Popup, Toast } from '@ymba/ym-ui';
  import { handleRedirectAPPPage, isAppWebView, projectJump } from '@/utils';

  export default {
    name: 'ExperienceVipReceiveResultPopup',
    components: {
      'ym-popup': Popup,
    },
    data() {
      return {
        visible: false,
        list: [
          {
            title: '《孩子一听就入迷的三国演义》',
            type: 'audio',
            id: 155,
          },
          {
            title: '《世界史剧场：带孩子趣看人类历史》',
            type: 'audio',
            id: 159,
          },
          {
            title: '《福尔摩斯创意写作课》',
            type: 'audio',
            id: 163,
          },
        ],
      };
    },
    props: {
      show: {
        type: Boolean,
        required: true,
      },
      closeOnClickOverlay: {
        type: Boolean,
        default: true,
      },
      status: {
        type: String,
        required: true,
      },
      isReceived: {
        type: Boolean,
      },
      isNewMember: {
        type: Boolean,
      },
      giftIndex: {
        type: Number,
        required: true,
      },
    },
    computed: {
      inAppWebView() {
        return isAppWebView();
      },
    },
    watch: {
      show(val) {
        this.visible = val;
      },
      visible(val) {
        this.$emit('update:show', val);
      },
    },
    methods: {
      handleClose() {
        this.visible = false;
      },
      handleToHome() {
        if (this.inAppWebView) {
          const appSelectPage = 'youthmba://million/read?type=selectHome';
          handleRedirectAPPPage(appSelectPage);
          return;
        }
        projectJump({
          name: 'MillionReadSelect',
        });
      },
      async handleStartLearn() {
        const toastLoading = Toast.loading();
        await this.handleToHome();
        this.handleClose();
        toastLoading.clear();
      },
      handleToAudioDetail(id) {
        this.handleClose();
        this.$router.push({
          name: 'AudioDetail',
          params: {
            id,
          },
        });
      },
      handleToCoupon() {
        this.$router.push({
          name: 'MyCoupon',
        });
      },
      handleBack() {
        this.$emit('back-app');
        this.handleClose();
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .experience-vip-receive-result {
    border-radius: 16px;
    width: 570px;
    overflow-y: visible;
    &-popup {
      background: transparent;
    }
    &-success-container {
      box-sizing: border-box;
      width: 580px;
      display: flex;
      align-items: center;
      padding: @size-extra-small;
      background: linear-gradient(180deg, #ffa104 0%, #ff7600 100%);
      border-radius: 24px;
      &-content {
        box-sizing: border-box;
        position: relative;
        width: 560px;
        height: 100%;
        padding-top: 96px;
        padding-bottom: 32px;
        display: flex;
        flex-direction: column;
        align-items: center;
        border-radius: 20px;
      }
      .success-info-title {
        position: absolute;
        top: -23px;
        left: 0;
        right: 0;
        width: 286px;
        height: 80px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #ff5d00;
        font-size: @font-size-large;
        font-weight: @font-weight-strong;
        line-height: 1;
        background: url('~@/assets/img/welfare/popup_title_bg.png') no-repeat;
        background-size: 100% 100%;
      }
      .gift-list {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      }
      .gift-list-item {
        box-sizing: border-box;
        width: 520px;
        height: 140px;
        margin-bottom: @size-small;
        padding: 0 @size-base / 2 0 @size-base;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: @color-white;
        box-shadow: 0 2px 4px 0 #ff7602;
        border-radius: 12px;
        &-title {
          width: 302px;
          color: #95461a;
          font-size: 26px;
          font-weight: @font-weight-strong;
          line-height: 1.4;
          &.coupon {
            margin-bottom: @size-extra-small;
            color: #951a1a;
          }
        }
        &-action {
          width: 140px;
          height: 60px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: @color-white;
          font-size: @font-size-small;
          font-weight: @font-weight-strong;
          line-height: 1;
          background: linear-gradient(180deg, #ffb500 0%, #ff7e0b 100%);
          border-radius: 30px;
          &.coupon {
            background: linear-gradient(180deg, #ff7070 0%, #ff2900 100%);
          }
        }
        &.coupon {
          width: 538px;
          height: 158px;
          padding: 0 23px 0 38px;
          background: url('~@/assets/img/welfare/coupon_bg.png') no-repeat;
          background-size: 538px 158px;
          box-shadow: none;
        }
      }
      .success-skip-button {
        width: 360px;
        height: 88px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #ffcbc1;
        font-size: @font-size-base;
        line-height: 1.3;
        border: 1px solid #ffcbc1;
        border-radius: 44px;
      }
    }
    &-fail-container {
      box-sizing: border-box;
      position: relative;
      width: 580px;
      padding-top: 124px;
      padding-bottom: @size-medium;
      background: @color-white;
      border-radius: 24px;
      .fail-header {
        position: absolute;
        top: -14px;
        left: 0;
        right: 0;
        width: 286px;
        height: 80px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #ff5d00;
        font-size: @font-size-large;
        font-weight: @font-weight-strong;
        line-height: 1.1;
        background: url('~@/assets/img/welfare/popup_title_bg.png') no-repeat;
        background-size: 100% 100%;
      }
      .fail-info {
        box-sizing: border-box;
        margin-bottom: 64px;
        padding: 0 40px;
        color: @color-text-base;
        font-size: 30px;
        line-height: 1.4;
        text-align: center;
      }
      .fail-btn {
        width: 288px;
        height: 88px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #e92121;
        font-size: @font-size-large;
        font-weight: @font-weight-strong;
        line-height: 1.2;
        background: linear-gradient(180deg, #ffeba4 0%, #ffbc1c 100%);
        border-radius: 44px;
      }
    }
    &-popup-close {
      position: absolute;
      bottom: -2 * @size-extra-medium;
      left: 0;
      right: 0;
      margin: 0 auto;
      width: @size-large;
      height: @size-large;
      font-size: @size-large;
      color: @color-placeholder;
    }
  }
</style>
